import { Icon } from '@iconify/react'

import { NavBarLink, RouterLinks } from '@/types'

// Router public
export const ROUTER_PUBLIC_LINKS = {
  auth: { path: '/auth' },
  authSignin: { path: '/auth/signin' },
  authRegister: { path: '/auth/register' },
  authOtp: { path: '/auth/otp' },
  signin: { path: '/signin/:hash' },
  not_authorized: { path: '/notauthorized' },
  not_found: { path: '*' },
  legal_cgu: { path: '/legal/cgu' },
  legal_cgu_lang: { path: '/legal/:lang/cgu' },
} as const

// Router private
export const ROUTER_PRIVATE_LINKS: RouterLinks = {
  home: { path: '/home', ability: { action: 'get', screen: 'home' } },
  devices: { path: '/devices', ability: { action: 'get', screen: 'devices' } },
  deviceDetails: { path: '/devices/:id', ability: { action: 'get', screen: 'devices' } },
  store: { path: '/store', ability: { action: 'get', screen: 'store' } },
  calculator: { path: '/store/calculator', ability: { action: 'get', screen: 'store' } },
  stock: { path: '/stock', ability: { action: 'get', screen: 'stock' } },
  sites: { path: '/sites', ability: { action: 'get', screen: 'sites' } },
  siteCreation: { path: '/sites/new', ability: { action: 'get', screen: 'sites' } },
  siteDetails: { path: '/sites/:id', ability: { action: 'get', screen: 'sites' } },
  spareparts: { path: '/spareparts', ability: { action: 'get', screen: 'spareparts' } },
  statistics: { path: '/statistics', ability: { action: 'get', screen: 'statistics' } },
  profile: { path: '/profile', ability: { action: 'get', screen: 'profile' } },
} as const

export const NAVBAR_LINKS: NavBarLink[] = [
  {
    ...ROUTER_PRIVATE_LINKS.home,
    label: 'navbar.home',
    icon: <Icon icon="mdi:home" />,
    isProd: true,
  },
  {
    ...ROUTER_PRIVATE_LINKS.devices,
    label: 'navbar.devices',
    icon: <Icon icon="mdi:mobile-devices" />,
    isProd: false,
  },
  {
    ...ROUTER_PRIVATE_LINKS.store,
    label: 'navbar.store',
    icon: <Icon icon="mdi:shopping-outline" />,
    isProd: true,
  },
  {
    ...ROUTER_PRIVATE_LINKS.stock,
    label: 'navbar.stock',
    icon: <Icon icon="mdi:box-outline" />,
    isProd: false,
  },
  {
    ...ROUTER_PRIVATE_LINKS.sites,
    label: 'navbar.sites',
    icon: <Icon icon="mdi:construction-outline" />,
    isProd: false,
  },
  {
    ...ROUTER_PRIVATE_LINKS.spareparts,
    label: 'navbar.spareparts',
    icon: <Icon icon="mdi:wrench-outline" />,
    isProd: true,
  },
  {
    ...ROUTER_PRIVATE_LINKS.statistics,
    label: 'navbar.statistics',
    icon: <Icon icon="mdi:chart-box-outline" />,
    isProd: true,
  },
] as const
